// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Divider } from '@livechat/design-system'

const Tutorial = ({ auth, onDisconnected }) => {
  return (
    <div
      css={css`
        padding: 20px;
      `}
    >
      <div>
        <div
          css={css`
            margin-bottom: 15px;
          `}
        >
          <h5
            css={css`
              font-size: 16px;
              line-height: 24px;
              font-weight: 600;
              margin-top: 0;
              margin-bottom: 0;
            `}
          >
            How it works?
          </h5>
          <Divider />
          <div>
            See the{' '}
            <a
              href="https://www.sikoraworks.com/apps/slack-for-livechat"
              target="_blank"
              rel="noopener noreferrer"
            >
              tutorial
            </a>{' '}
            on how to properly configure this app with your LiveChat account.
          </div>
        </div>

        <div
          css={css`
            margin-bottom: 15px;
          `}
        >
          <h5
            css={css`
              font-size: 16px;
              line-height: 24px;
              font-weight: 600;
              margin-top: 0;
              margin-bottom: 0;
            `}
          >
            Video tutorials
          </h5>
          <Divider />
          <div>
            <p>1. Basic setup</p>
            <div
              css={css`
                position: relative;
                padding-bottom: 62.5%;
                height: 0;
              `}
            >
              <iframe
                title="Slack for LiveChat - basic setup"
                src="https://www.loom.com/embed/08b78fda007e41d893704ad398f1d7ad"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                css={css`
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                `}
              ></iframe>

              <p>2. Slack for LiveChat - reply in public channel</p>
              <div
                css={css`
                  position: relative;
                  padding-bottom: 62.5%;
                  height: 0;
                `}
              >
                <iframe
                  title="Slack for LiveChat - reply in public channel"
                  src="https://www.loom.com/embed/aa15703d0d244256991ff193bb06ce57"
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                  css={css`
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  `}
                ></iframe>
              </div>

              <p>3. Slack for LivChat - notifications only</p>
              <div
                css={css`
                  position: relative;
                  padding-bottom: 62.5%;
                  height: 0;
                `}
              >
                <iframe
                  title="Slack for LivChat - notifications only"
                  src="https://www.loom.com/embed/3a609b15f7ca4c23bbd336c991e120d7"
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                  css={css`
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  `}
                ></iframe>
              </div>

              <p>4. Slack for LiveChat - Use Support Agent</p>
              <div
                css={css`
                  position: relative;
                  padding-bottom: 62.5%;
                  height: 0;
                `}
              >
                <iframe
                  title="Slack for LiveChat - Use Support Agent"
                  src="https://www.loom.com/embed/91dc893537d84f2b8b7e443fed227b07"
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                  css={css`
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  `}
                ></iframe>
              </div>

              <p>
                5. Slack for LiveChat - Initialise Slack for customer input only
              </p>
              <div
                css={css`
                  position: relative;
                  padding-bottom: 62.5%;
                  height: 0;
                `}
              >
                <iframe
                  title="Slack for LiveChat - Initialise Slack for customer input only"
                  src="https://www.loom.com/embed/ef94eb94a5804a4e8bc469f21531a0d0"
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                  css={css`
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  `}
                ></iframe>
              </div>

              <p>6. Slack for LiveChat - closing the chat</p>
              <div
                css={css`
                  position: relative;
                  padding-bottom: 62.5%;
                  height: 0;
                `}
              >
                <iframe
                  title="Slack for LiveChat - closing the chat"
                  src="https://www.loom.com/embed/6a2fb1db851242ef8f781a62cb4638bb"
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                  css={css`
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  `}
                ></iframe>
              </div>

              <p>7. Slack for LiveChat - Initialise Slack for ChatBot</p>
              <div
                css={css`
                  position: relative;
                  padding-bottom: 62.5%;
                  height: 0;
                `}
              >
                <iframe
                  title="Slack for LiveChat - Initialise Slack for ChatBot"
                  src="https://www.loom.com/embed/32b516fdc7f541ceafbd690198c6dded"
                  frameborder="0"
                  webkitallowfullscreen
                  mozallowfullscreen
                  allowfullscreen
                  css={css`
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  `}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Tutorial
